import { clientAPI } from '../configs/configs'
import store from '../store'

const urlBase =  '/returns'
export default class GeneralSettings {
  static async listWalletHistoric() {
    const brand = store.getters['brand/getBrand'] || {}     
    const defaultFilters = {     
      mar_id: brand?.id || '', 
    }
    const request_query_string = new URLSearchParams(defaultFilters)
    
    return new Promise((res, rej) => {     
      clientAPI
        .get(`${urlBase}/settings/b2c`, {params: request_query_string})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })     
    })
  } 
}